import { RotateCw } from 'lucide-react'
import { useTranslation } from 'react-i18next'

const Footer = ({ setShowConfirmDialog }: { setShowConfirmDialog: (value: boolean) => void }) => {
  const { t } = useTranslation()

  const handleResetClick = () => {
    setShowConfirmDialog(true)
  }

  return (
    <>
      <div className="shrink-0 bg-border flex justify-between items-center px-4 h-7 text-xs text-muted-foreground rounded-md">
        <button className="flex items-center gap-1" onClick={handleResetClick}>
          <RotateCw size={16} />
          {t('footer.reset', 'Reset')}
        </button>
        <a href="https://linkando.com/webplays" className="hidden" target="_blank">
          {t('footer.powered_by', 'About WebPlays')}
        </a>
        {/* A container for the weglot language switcher */}
        <div id="lang-switcher" />
      </div>
    </>
  )
}

export default Footer
